import camelCase from 'lodash/camelCase';
import { computed, makeObservable } from 'mobx';
import moment from 'moment';
import { CamelCase } from 'type-fest';
import { ItemChore } from 'src/types/proto/transactions';
import Item, { type ItemJson, type ItemStore } from './item';

export type ChoreJson = ItemJson<'CHORE'> & {
  chore: ItemChore & {
    markup: unknown;
    unknown: unknown;
  };
};

export default class Chore extends Item<ItemStore, ChoreJson> {
  constructor(store: ItemStore, json: ChoreJson) {
    super(store, json);

    makeObservable(this);
  }

  @computed
  get itemIds() {
    return this.kindItem.itemIds;
  }

  @computed
  get priority() {
    return this.kindItem.priority;
  }

  @computed
  get comment() {
    return this.kindItem.comment;
  }

  @computed
  get markup() {
    return this.kindItem.markup;
  }

  @computed
  get didStart() {
    return this.kindItem.didStart;
  }

  @computed
  get allowedRoles() {
    return this.kindItem.allowedRoles;
  }

  @computed
  get choreKind() {
    return this.kindItem.choreKind;
  }

  @computed
  get status() {
    return this.kindItem.status;
  }

  @computed
  get statusUpdatedAt() {
    return this.kindItem.statusUpdatedAt;
  }

  @computed
  get isNew() {
    return moment(Number(this.createdAt)) > moment().subtract(2, 'day');
  }

  @computed
  get choreKindItem() {
    return (
      this.kindItem[
        camelCase(this.choreKind) as CamelCase<ItemChore['choreKind']>
      ] || {}
    );
  }

  @computed
  get isHideable() {
    return this.id && this.id !== '0';
  }

  @computed
  get isHidden() {
    const myUser =
      this.store.parent.account.user && this.store.parent.account.user.id;
    if (!myUser) {
      return true;
    }
    return (
      this.kindItem.hiddenForUsers &&
      this.kindItem.hiddenForUsers.includes(myUser)
    );
  }
}
